import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'Who is Lynkr for?',
    a:
      'Lynkr is completely suitable for content creators, sales teams, founders, and anyone looking to reach wider audiences, introduce their products, and build a reliable digital presence.'
  },
  {
    q: 'How does Lynkr protect my data?',
    a:
      'We employ enterprise-grade encryption and security measures to protect your information. Your data is never shared with third parties and remains completely confidential.'
  },
  {
    q: 'Can Lynkr write in my voice?',
    a:
      'Yes! Lynkr analyzes your posts as well as already trending ones, utilizing your writing style in proven content formats and structures to maximize performance.'
  },
  {
    q: 'How can I start using Lynkr?',
    a:
      'Join our waitlist and we will notify you as soon as we launch!'
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(prev => (prev === i ? null : i));
  };

  return (
    <section id="faq" className="py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-3xl md:text-5xl font-bold text-gray-900 mb-12 text-center">
          Frequently Asked Questions
        </h3>

        <div className="space-y-4">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="bg-gray-50 rounded-2xl border border-transparent overflow-hidden transition-shadow duration-300 hover:shadow-lg"
              >
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${idx}`}
                  className="w-full flex items-center justify-between gap-4 p-6"
                >
                  <div className="text-left">
                    <h4 className="text-base md:text-xl font-bold text-gray-900">{faq.q}</h4>
                  </div>

                  <div
                    className={`flex items-center justify-center transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : 'rotate-0'
                    }`}
                    aria-hidden
                  >
                    <ChevronDown className="w-6 h-6 text-gray-600" />
                  </div>
                </button>

                {/* Animated panel: use max-h to animate height, opacity for content fade */}
                <div
                  id={`faq-panel-${idx}`}
                  role="region"
                  aria-labelledby={`faq-button-${idx}`}
                  className={`px-6 overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-72 py-6 opacity-100' : 'max-h-0 py-0 opacity-0'
                  }`}
                >
                  <p className="text-gray-600 text-sm md:text-lg leading-relaxed">{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
